import { clone, flow, getRoot, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { allOptionCode } from "../../components/project/documentobjective/ProjectTypeDropdownList";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import LogsAPI from "./LogService";
import { IProjectModel, ProjectModel, ResolutionModel } from "../project/ProjectModel";
import { ILoanPeriodsModel, ILoanSourcesModel, LoanPeriodsModel } from "../share/LoanModel";
import { PaginationModel } from "../share/PagingModel";
import { LoanSourcesModel } from "../share/LoanModel";
import { LOVGroupModel } from "../org/OrganizeModel";

export const LogFiveYearPlanItem = types
    .model("LogFiveYearPlanItem", {
        planProjecID: customtypes.optional(types.number, 0),
        planID: customtypes.optional(types.number, 0),
        projectID: customtypes.optional(types.number, 0),
        projectDetail: types.optional(ProjectModel, {}),
        loanByYears: types.optional(types.array(LoanPeriodsModel), []),
        loanPeriods: types.optional(types.array(LoanPeriodsModel), []),
        // sourceLoanGroup: types.optional(types.array(LoanSourcesModel), []),
        sourceLoanGroup: types.optional(types.array(LoanSourcesModel), []),
        error: customtypes.optional(ErrorModel, {}),
        coordinatorName: customtypes.optional(types.string, ""),
        coordinatorPosition: customtypes.optional(types.string, ""),
        coordinatorTel: customtypes.optional(types.string, ""),
        coordinatorEmail: customtypes.optional(types.string, ""),
        resolutions: customtypes.optional(types.array(ResolutionModel), []),
        files: customtypes.optional(types.array(ResolutionModel), []),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setError: (e: any) => {
            self.error.tigger = true;
            self.error.code = e.code;
            self.error.title = e.name;
            self.error.message = e.message;
            self.error.technicalStack = e.technicalStack;
        },
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;

        },
        onAddResolution: () => {
            self.resolutions.push(ResolutionModel.create({
                no: self.resolutions.length + 1,
                file: null // ResolutionFileModel.create({})
            }));
        },
        onRemoveResolution: (index: number) => {
            self.resolutions.splice(index, 1);
        },
        onAddFile: () => {
            self.files.push(ResolutionModel.create({
                no: self.files.length + 1,
                date: '2021-1-1',
                amount: 0,
                file: null
            }));
        },
        onRemoveFile: (index: number) => {
            self.files.splice(index, 1);
        },
    }));
export type ILogFiveYearPlanItem = typeof LogFiveYearPlanItem.Type;

export const LogFiveYearPlanBodyModel = types
    .model("LogFiveYearPlanBodyModel", {
        list: types.optional(types.array(LogFiveYearPlanItem), []),
        startYear: types.maybeNull(types.number),
        projectType: types.optional(types.string, allOptionCode),
        projectTypeLabel: types.maybe(types.string),
        selectedProjectId: types.maybe(types.number),
        paging: types.optional(PaginationModel, {}),
        error: customtypes.optional(ErrorModel, {}),
        loading: types.optional(types.boolean, false),
        lovSourceLoans: types.optional(LOVGroupModel, {}),
        selectedProjectIdArray: types.optional(types.array(types.number), []),
        projectTypeForArray: types.optional(types.string, allOptionCode),
        projectTypeLabelForArray: types.maybe(types.string),
    })
    .views((self: any) => ({
    }))
    .actions((self: any) => ({
        getFiveYearPlanLogs: flow(function* (logId: number) {
            try {
                self.loading = true;
                const result = yield LogsAPI.getFiveYearLogPlanBody(logId);
                self.lovSourceLoans!.setGroupCode("SOURCELOAN");
                self.lovSourceLoans!.getLOVByGroup();
                self.list = result.data;
                self.setLoanPeriodsYears();
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        setLoanPeriodsYears: () => {
            self.list.forEach((fiveYearPlanItem: ILogFiveYearPlanItem) => {
                fiveYearPlanItem.loanByYears.forEach((loanByYear: ILoanPeriodsModel) => {
                    loanByYear.loanSources.forEach((loanSource: ILoanSourcesModel) => {
                        if (loanSource.sourceType === "F" && !loanSource.currency) {
                            loanSource.setField({
                                fieldname: "currency",
                                value: "USD",
                            });

                        }
                        if (loanSource.sourceType === "L" && !loanSource.currency) {
                            loanSource.setField({
                                fieldname: "currency",
                                value: "THB",
                            });
                        }

                        let item = fiveYearPlanItem.sourceLoanGroup.find(i => i.currency == loanSource.currency && i.sourceLoan.id == loanSource.sourceLoan.id);
                        if (!item) {
                            fiveYearPlanItem.sourceLoanGroup.push({
                                currency: loanSource.currency,
                                sourceLoan: {
                                    id: loanSource.sourceLoan.id,
                                    code: loanSource.sourceLoan.code,
                                    description: loanSource.sourceLoan.description
                                }
                            })
                        }

                    });
                    fiveYearPlanItem.loanPeriods.push(loanByYear.loanPeriodsJSON);
                    fiveYearPlanItem.sourceLoanGroup = fiveYearPlanItem.sourceLoanGroup.sort((a, b) => a.sourceLoan.code > b.sourceLoan.code ? 1 : -1);

                });

            });


        },
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        onSelectedProject: (selectedProjectId?: number) => {
            self.selectedProjectId = selectedProjectId;
        },
        onSelectedFilter: (projectTypeLabel: string, projectType: string) => {
            self.setDefaultPagination();
            self.projectType = projectType;
            self.projectTypeLabel = projectTypeLabel;
            self.getFiveYearPlanBody();
        },
        onSearchTextFilter: (value: any) => {
            self.setDefaultPagination();
            self.paging.searchText = value;
            self.getFiveYearPlanBody();
        },
        setPagination: (result: any) => {
            self.paging.pageSize = result.pageSize;
            self.paging.pageNo = result.pageNo;
            self.paging.totalRow = result.totalRow;
        },
        onSelectedPage: (pageNo: number) => {
            self.paging.pageNo = pageNo;
            self.getFiveYearPlanBody();
        },
        setDefaultPagination: () => {
            self.paging.pageNo = 1;
        },
        resetAll: () => {
            self.list = [];
            self.paging = {};
        },
        // ฟังก์ชันสำหรับจัดการ Array
        addSelectedProjectId: (projectId: number) => {
            if (!self.selectedProjectIdArray.includes(projectId)) {
                self.selectedProjectIdArray.push(projectId);
            }
        },
        removeSelectedProjectId: (projectId: number) => {
            const index = self.selectedProjectIdArray.indexOf(projectId);
            if (index > -1) {
                self.selectedProjectIdArray.splice(index, 1);
            }
        },
        clearSelectedProjectIdArray: () => {
            self.selectedProjectIdArray = [];
        },
    }));

export type ILogFiveYearPlanBodyModel = typeof LogFiveYearPlanBodyModel.Type;
